module.exports = __webpack_public_path__ + "media/images/slide-11-2e8c1d691ac522ec097461be4fbb7bc2.jpg";